<script setup lang="ts">
import Button from "primevue/button";
import { useAuthModal } from "@/features/auth/store";
import router from "@/router";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const loadingState = ref(false);

function loginHandler() {
  loadingState.value = true;
  useAuthModal().showAuthModal("signIn");
  loadingState.value = false;
}

onMounted(() => {
  router.push({ path: "/" });
});
</script>

<template>
  <div class="registration-end__content">
    <span class="registration-end__title h2">{{ t("signup.registration_success") }}</span>
    <div class="registration-end__content__wrapper">
      <div class="login">
        <Button
          class="login-btn"
          :label="t('signup.sign_in_button')"
          :loading="loadingState"
          @click="loginHandler"
        />
      </div>
    </div>
  </div>
</template>
<style scoped>
.registration-end__content {
  display: flex;
  border-radius: 40px;
  padding: 40px;
  gap: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.registration-end__title {
  text-align: center;
}

.registration-end__content__wrapper {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.registration-end_third_party button {
  display: flex;
  border-radius: 8px;
  width: 160px;
  height: 48px;
  gap: 8px;
  padding: 12px 20px;
}

.login {
  display: flex;
  justify-content: center;
  width: 100%;
}

.login-btn {
  width: 100%;
}
</style>
